/**
 * Pre-compiled de messages for RangeCalendar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  nextMonth: `Nächsten Monat`,
  nextYear: `Nächstes Jahr`,
  previousMonth: `Letzten Monat`,
  previousYear: `Letztes Jahr`,
};
